function onSwymLoadCallback(swat) {
  swat.fetchLists({
    callbackFn: function (lists) {
      if (!lists || lists.length === 0) {
        // No wishlist exists — create one
        let listConfig = {
          "lname": "MY WISHLIST", // unique list name.
        };
  
        // Define success callback
        let onSuccess = function(newList) { 
          console.log("✅ Successfully created a new List", newList);
          window.globalListArray = [newList];
          window.dispatchEvent(new CustomEvent('wishlistdata', { detail: [newList] }));
        }
  
        // Define error callback
        let onError = function(error) {
          console.error("❌ Error while creating a List", error);
        }
  
        // Call the createList function
        swat.createList(listConfig, onSuccess, onError);
  
      } else {
        // Wishlist exists
        window.globalListArray = lists;
        console.log("✅ Wishlist(s) loaded:", lists);
        window.dispatchEvent(new CustomEvent('wishlistdata', { detail: lists }));
      }
    },
    errorFn: function (err) {
      console.error("❌ Error fetching wishlists:", err);
    }
  });
    
    async function persistWishlistButtonsState() {
        return new Promise((resolve, reject) => {
          let onSuccess = function (lists) {
            globalListArray = lists;
            lists.forEach((list) => {
              list.listcontents.forEach((product) => {
                let productId = product.empi;
                let buttonToFill = document.querySelector(`button#swym-collections[data-product-id="${productId}"]`);
                let productButtonToFill = document.querySelector(`button#swym-product[data-product-id="${productId}"]`);
                if (buttonToFill && !buttonToFill.classList.contains('swym-added')) {
                  SwymUtils.addClass(buttonToFill, "swym-added");
                //   SwymUtils.addClass(buttonToFill, "variant-in-wishlist");
                }
                if (productButtonToFill && !productButtonToFill.classList.contains('swym-added')) {
                  SwymUtils.addClass(productButtonToFill, "swym-added");
                //   SwymUtils.addClass(buttonToFill, "variant-in-wishlist");
                }
              });
            });
            resolve(); 
          };
      
          let onError = function (error) {
            console.error("Error while fetching all Lists", error);
            reject(error);
          };
      
          swat.fetchLists({
            callbackFn: onSuccess,
            errorFn: onError,
          });
        });
      }
      persistWishlistButtonsState(); 
  }
  
  if (!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(onSwymLoadCallback);
  document.addEventListener("wishRefresh", () => {
    if (!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(onSwymLoadCallback);
  });
   

// Step 2: Handle adding/removing from the single wishlist 
function handleSingleWishlist(product, button) {
  if (!window.globalListArray || !globalListArray[0]) {
    console.warn("Wishlist not ready yet. Try again shortly.");
    return;
  }

  const lid = globalListArray[0].lid;

  const onSuccess = function () {
    button.classList.toggle("swym-added");
    console.log(
      button.classList.contains("swym-added")
        ? "Product added to wishlist"
        : "Product removed from wishlist"
    );
  };

  const onError = function (error) {
    console.log("Error while adding/removing the product", error);
  };

  if (!button.classList.contains("swym-added")) { 
    _swat.addToList(lid, product, onSuccess, onError);
    console.log(product);
    wishPopNoti(product);
  } else {
    _swat.deleteFromList(lid, product, onSuccess, onError); 
  }
}

// Function to attach wishlist event listeners
function attachWishlistListeners() {
  const wishButtons = document.querySelectorAll(".swym-button");

  wishButtons.forEach((button) => {
    // Remove existing listeners to avoid multiple bindings
    button.removeEventListener("click", handleWishlistClick);
    button.addEventListener("click", handleWishlistClick);
  });
}

// Handler function for wishlist button clicks
function handleWishlistClick(event) {
  const button = event.currentTarget;

  const product = {
    empi: button.getAttribute("data-product-id"),
    epi: button.getAttribute("data-variant-id"),
    du: button.getAttribute("data-product-url"),
  };

  handleSingleWishlist(product, button);
}

// Attach listeners on DOM load
document.addEventListener("DOMContentLoaded", attachWishlistListeners);

// Reattach listeners on custom event
document.addEventListener("wishRefresh", attachWishlistListeners);


async function wishPopNoti(product) {
    let mainWishNoti = document.querySelector(".WI_wiahNoti_main");
    let inWishNoti = document.querySelector(".WI_wiahNoti_in");
    let url = (product.du).split('?')[0];
    try {
        let res = await fetch(url+".json");
        let data = await res.json();
        var wishNotiProTitle = data.product.title;
        var wishNotiProImg = data.product.images[0].src;
    } catch (error) {
        console.error("Error in wishPopNoti:", error);
        
    }
    inWishNoti.querySelector(".WI_wiahNoti_img_src").src = wishNotiProImg;
    inWishNoti.querySelector(".WI_wiahNoti_text_title").innerText = wishNotiProTitle;
    mainWishNoti.style.display = "flex";
    setTimeout(() => {
        inWishNoti.style.opacity = "1";
        inWishNoti.style.transform = "translateX(0)";
    }, 10);
    setTimeout(() => {
        inWishNoti.style.opacity = "0";
        inWishNoti.style.transform = "translateX(100%)";
        setTimeout(() => {
            mainWishNoti.style.display = "none";
        }, 210);
    }, 2510);
}